export const Box = () => {
  return (
    <section className="box">
      <div className="box__content">
        <div className="item-box">
          <div className="image-box">
            <div className="btn-black left">
              <a href="https://www.hakahonu.cl/textil/mujer.html" target='_parent' id='C2.1'>MUJER</a>
            </div>
            <div className="btn-black right">
              <a href="https://www.hakahonu.cl/textil/hombre.html" target='_parent' id='C2.2'>HOMBRE</a>
            </div>
          </div>
          <article className="txt">
            <h2>TEXTIL</h2>
            <p>ESTILAZOS DE LA TORTUGA</p>
          </article>
        </div>
        <div className="item-box">
          <div className="image-box">
            <div className="btn-black">
              <a href="https://www.hakahonu.cl/sandalias-verano.html" target='_parent' id='C1.2'>VER MÁS</a>
            </div>
          </div>
          <article className="txt">
            <h2>SANDALIAS</h2>
            <p>POR UN VERANO A PATA PELÁ</p>
          </article>
        </div>
        <div className="item-box">
          <div className="image-box">
            <div className="btn-black">
              <a href="https://www.hakahonu.cl/calcetines-y-jockeys.html" target='_parent' id='C1.1'>VER MÁS</a>
            </div>
          </div>
          <article className="txt">
            <h2>JOCKEYS Y CALCETINES</h2>
            <p>COMODIDAD Y ESTILO PARA CUALQUIER LADO</p>
          </article>
        </div>
        <div className="item-box">
          <div className="image-box">
            <div className="btn-black left">
              <a href="https://www.hakahonu.cl/mujeres/shoes.html" target='_parent' id='C2.3'>MUJER</a>
            </div>
            <div className="btn-black right">
              <a href="https://www.hakahonu.cl/hombres/shoes.html" target='_parent' id='C2.4'>HOMBRE</a>
            </div>
          </div>
          <article className="txt">
            <h2>CALZADO</h2>
            <p>LA HUELLA DE HAKA</p>
          </article>
        </div>
      </div>
    </section>
  )
}
